import { render, staticRenderFns } from "./createProductLocation.vue?vue&type=template&id=15faf120&"
import script from "./createProductLocation.vue?vue&type=script&lang=js&"
export * from "./createProductLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports